var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCmLanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 675 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#2f3a81;}.cls-3{fill:#fcfcfc;opacity:0.08;mix-blend-mode:screen;}.cls-4{fill:#85a8ff;}.cls-5{fill:#8fa6b5;opacity:0.42;mix-blend-mode:multiply;}.cls-14,.cls-6{fill:#e4f2fd;}.cls-7{fill:#011c53;}.cls-8{fill:#82e8c1;}.cls-9{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_9);}.cls-10{fill:#c5d5dd;}.cls-11{fill:#626bc1;}.cls-12{fill:#f38f1f;}.cls-13{fill:#c6d0dc;}.cls-14{opacity:0.5;}.cls-15{fill:#acbfc6;}.cls-16{fill:#fff;}.cls-17{opacity:0.46;}.cls-18{fill:#89fce5;}.cls-19{opacity:0.73;}.cls-20{fill:url(#linear-gradient);}.cls-21{fill:#f5f8fa;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_9",
    x1: 398.47,
    y1: 169.54,
    x2: 504.43,
    y2: 169.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5aa1e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72d4c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 158.98,
    y1: 210.71,
    x2: 349.67,
    y2: 210.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f38f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffaf54"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Client-management-illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 675,
    height: 450
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "123.13 229.54 363.61 369.3 364.56 368.75 124.07 229 123.13 229.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "338.77 228.24 579.25 367.99 580.19 367.45 339.71 227.69 338.77 228.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "317.74 177.93 558.22 317.69 559.17 317.14 318.68 177.39 317.74 177.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "113.02 156.22 353.5 295.97 354.45 295.43 113.97 155.68 113.02 156.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "348.28 368.94 334.86 361.19 353.5 350.42 366.93 358.18 348.28 368.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "506.99 278.89 493.56 271.14 512.21 260.38 525.63 268.13 506.99 278.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "157.15 239.88 125.89 221.83 169.31 196.77 200.57 214.81 157.15 239.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M512.54,120.89,411.35,62.47c-1.32-.76-2.39.05-2.39,1.81v74.08l106,61.18V125.46A5.74,5.74,0,0,0,512.54,120.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M528,109.87,426.84,51.45c-1.32-.76-2.39,0-2.39,1.81v74.08l106,61.18V114.44A5.73,5.73,0,0,0,528,109.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370.72,135.82,292.88,90.88c-1-.58-1.83,0-1.83,1.39v57l81.51,47.06v-57A4.4,4.4,0,0,0,370.72,135.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "258.32 249 210.76 221.54 207.79 223.25 204.88 221.57 138.82 259.7 186.38 287.16 189.35 285.45 192.26 287.13 258.32 249"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261.18,305.74l-42.93,24.95a12.07,12.07,0,0,1-10.92,0l-29.39-17a3.87,3.87,0,0,1-2.28-3.19v3a3.89,3.89,0,0,0,2.28,3.19l29.4,17a12.05,12.05,0,0,0,10.91,0l42.93-24.95a3.83,3.83,0,0,0,2.24-3.14v-3A3.83,3.83,0,0,1,261.18,305.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M484.44,204.35a10.54,10.54,0,0,0-4.79-8.29l-4.16-2.41V304l-84.82,50.63-143.25-84.1-2.66,1.55a3.36,3.36,0,0,0-2,2.76h0v3.35a3.38,3.38,0,0,0,2,2.79l139.45,80.52a10.57,10.57,0,0,0,9.58,0l87.78-51v-3.14l2.55-1.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "504.43 214.57 398.47 153.39 398.47 81.2 504.43 142.38 504.43 214.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M502,135.92,400.86,77.5c-1.32-.76-2.39,0-2.39,1.81v1.93l106,61.18v-1.93A5.73,5.73,0,0,0,502,135.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M405.7,83.06c0,.64-.45.9-1,.58a2.26,2.26,0,0,1-1-1.75c0-.64.46-.9,1-.58A2.22,2.22,0,0,1,405.7,83.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M409,84.93c0,.65-.45.91-1,.59a2.26,2.26,0,0,1-1-1.75c0-.64.45-.9,1-.58A2.21,2.21,0,0,1,409,84.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M412.2,86.81c0,.64-.45.9-1,.58a2.21,2.21,0,0,1-1-1.74c0-.65.45-.91,1-.59A2.26,2.26,0,0,1,412.2,86.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M398.47,153.39l106,61.18v-38s-3.67,12-10.69,7.89c-8.39-4.84-9.05-19.67-14.3-22.7s-6.68,8.68-14.3,4.28-6.05-23.17-14.3-27.93c-8.53-4.93-6.37,23-14.3,18.38-6.66-3.85-7.64-19-14.19-22.81-6.16-3.56-6.52,10.49-15.41,5.35-3-1.75-6.76-8.3-8.47-14.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "426.76 106 403.68 92.67 403.68 90.37 426.76 103.7 426.76 106"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "436.54 117.07 403.68 98.1 403.68 96.85 436.54 115.83 436.54 117.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "436.54 119.8 403.68 100.82 403.68 99.58 436.54 118.55 436.54 119.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "430.28 118.91 403.68 103.55 403.68 102.31 430.28 117.66 430.28 118.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "453.29 132.81 448.69 130.16 448.69 128.92 453.29 131.57 453.29 132.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 407.77,
    y: 113.37,
    width: 0.36,
    height: 45.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 422.07,
    y: 121.63,
    width: 0.36,
    height: 45.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 436.36,
    y: 129.88,
    width: 0.36,
    height: 45.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 450.66,
    y: 138.14,
    width: 0.36,
    height: 45.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 464.96,
    y: 146.39,
    width: 0.36,
    height: 45.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 479.26,
    y: 154.65,
    width: 0.36,
    height: 45.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 493.56,
    y: 162.9,
    width: 0.36,
    height: 45.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M449,137.05c0-1.19.85-1.68,1.88-1.08a4.14,4.14,0,0,1,1.88,3.25c0,1.2-.84,1.68-1.88,1.09A4.18,4.18,0,0,1,449,137.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M332,216.11l149.05,86.06-87.78,51a10.52,10.52,0,0,1-9.57,0L244.24,272.68c-2.65-1.54-2.66-4,0-5.55Zm.61,90.43,6.94-4L290.34,274.1l-6.94,4,49.21,28.4Zm28.57,6.84,6.94-4-29-16.72-6.94,4,29,16.73Zm8.34-4.85,6.94-4-18.85-10.89-6.94,4,18.85,10.88ZM298.7,267.64l6.94-4-18.85-10.88-6.94,4,18.85,10.88Zm36.9,3.6-7,4,8.74,5,6.94-4-8.73-5.05Zm28.57,6.84-6.94,4,8.73,5.05,7-4-8.74-5Zm-8.34,4.85-6.94,4,8.73,5.05,6.95-4-8.74-5ZM343.94,266.4l-6.95,4,8.74,5.05,6.94-4-8.73-5Zm42.26,32.44,6.94-4-8.73-5-7,4,8.74,5Zm-8.34,4.85,6.94-4-8.74-5-6.94,4,8.74,5.05Zm-23.81-31.45-6.94,4,8.73,5.05,7-4-8.74-5Zm-8.34,4.84-6.94,4,8.73,5,6.95-4-8.74-5.05Zm81,45.12,6.95-4-8.74-5.05-6.94,4,8.73,5ZM325.48,265.4l-7,4,8.74,5,6.94-4-8.73-5Zm92.84,61.65,6.95-4-8.74-5-6.94,4,8.73,5Zm-84.5-66.5-6.95,4,8.74,5,6.95-4-8.74-5.05ZM307,262.8l6.94-4-8.73-5-6.95,4,8.74,5Zm91,52.57,6.94-4-8.73-5-6.95,4,8.74,5.05Zm8.34-4.85,6.94-4-8.73-5.05-6.95,4,8.74,5ZM315.38,258l6.94-4-8.73-5-6.95,4,8.74,5Zm92.82,63.26,6.95-4-8.73-5-6.95,4,8.73,5Zm8.34-4.85,6.95-4-8.73-5-6.95,4,8.73,5ZM295.13,247.88l-6.94,4,8.73,5,6.94-4-8.73-5Zm28.58,6.84-6.95,4,8.73,5,6.95-4-8.73-5ZM303.47,243l-6.94,4,8.73,5,6.94-4-8.73-5Zm11.9,16.53-6.95,4,8.73,5,7-4-8.73-5ZM366,288.77l-6.94,4,8.73,5,6.94-4-8.73-5Zm8.34-4.85-6.94,4,8.73,5,6.94-4-8.73-5Zm-22-22.37-6.94,4,8.74,5,6.94-4-8.74-5.05Zm20.24,11.68-6.94,4,8.73,5,6.94-4-8.73-5Zm22,20.76,6.94-4-8.74-5-6.94,4,8.74,5Zm-32.15-26.6-6.94,4,8.73,5,6.94-4-8.73-5.05Zm-20.23-11.68-7,4,8.74,5.05,6.94-4-8.73-5ZM435,317.36l6.94-4-8.73-5-6.94,4,8.73,5.05ZM318.92,280.94,312,285l8.73,5,6.94-4-8.73-5Zm45.41-26.39-6.94,4,8.73,5.05,6.94-4-8.73-5Zm-16.84,33.22-6.94,4,8.74,5,6.94-4-8.74-5.05Zm37.07-21.54-6.94,4,8.74,5.05,6.94-4-8.74-5Zm-57.3,9.86-6.94,4,8.73,5.05,6.94-4-8.73-5Zm-3.54-23,6.94-4-8.74-5-6.94,4,8.74,5.05Zm91,52.56,6.94-4-8.74-5-6.94,4,8.74,5Zm-61.93,12.55,6.94-4-8.74-5-6.94,4,8.74,5ZM406.59,287l6.94-4-8.74-5-6.94,4,8.74,5.05Zm-4.94,49.75,6.94-4-8.74-5-6.94,4,8.74,5Zm-72.62-50-6.94,4,8.74,5,6.94-4-8.74-5ZM308.8,275.1l-6.94,4,8.73,5,6.94-4-8.73-5ZM410,331.89l6.94-4-8.74-5-6.94,4,8.74,5Zm-92.85-61.64-6.94,4,8.73,5.05,6.94-4-8.73-5Zm37.07-21.54-6.94,4,8.73,5,6.94-4-8.73-5Zm20.23,11.68-6.94,4,8.74,5,6.94-4-8.74-5Zm-37.07,21.54-6.94,4,8.74,5.05,6.94-4-8.74-5Zm55.93,59.66,6.94-4-8.73-5-6.94,4,8.73,5Zm53.75-31.24,6.94-4-8.73-5.05-6.94,4,8.73,5ZM290.36,272.49l6.94-4-8.73-5-6.94,4,8.73,5Zm91.05,52.57,6.94-4-8.73-5-6.94,4,8.73,5Zm-8.34,4.85,6.94-4-8.73-5-6.94,4,8.73,5.05Zm-37.3-83.81,6.94-4L334,237l-6.94,4,8.74,5ZM282,277.34l6.94-4-8.74-5-6.94,4,8.74,5Zm107.73,42.87,6.94-4-8.73-5-6.94,4,8.73,5Zm37.07-21.54,6.94-4L425,289.59l-6.94,4,8.73,5Zm-1.94,12.84,6.94-4-8.73-5-6.94,4,8.73,5ZM332,249.87l-6.94,4,8.73,5,6.94-4-8.73-5Zm50.59,29.21-6.94,4,8.73,5,6.94-4-8.73-5Zm-70.82-40.89-6.94,4,8.73,5,6.94-4-8.73-5Zm79.72,92.71,6.94-4-8.73-5.05-6.94,4,8.73,5Zm8.34-4.85,6.94-4-8.73-5-6.94,4,8.73,5Zm-16.68,9.7,6.94-4-8.73-5-6.94,4,8.73,5.05Zm53.75-31.24,6.94-4-8.73-5-6.94,4,8.73,5Zm-156.7-37.86,6.94-4-8.73-5.05-6.94,4,8.73,5Zm18.44,2.61-6.94,4,8.73,5,6.94-4-8.73-5Zm8.34-4.85-6.94,4,8.74,5,6.94-4-8.74-5ZM271.9,271.5l6.94-4-8.73-5-6.94,4,8.73,5.05Zm72.19-28.63-6.94,4,8.73,5,6.94-4-8.73-5Zm72.61,50,6.94-4-8.73-5-6.94,4,8.73,5Zm-22-20.76-6.94,4,8.73,5,6.94-4-8.73-5Zm-52,40.31,6.94-4-8.73-5-6.94,4,8.73,5Zm-18.86-81.19-6.94,4,8.73,5,6.94-4-8.73-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M393.27,353.18a10.52,10.52,0,0,1-9.57,0h0L244.24,272.68a3.39,3.39,0,0,1-2-2.8v3.35a3.36,3.36,0,0,0,2,2.79l139.45,80.51h0a10.55,10.55,0,0,0,9.57,0l87.79-51v-3.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M476.56,192.35a10.54,10.54,0,0,1,4.78,8.29l-.29,101.53L332,216.11l.29-101.53c0-3,2.16-4.28,4.82-2.75ZM476,291l.26-90.77L337.32,120l-.25,90.77L476,291ZM406.82,154.77c-.75-.43-1.36-.09-1.36.78a3,3,0,0,0,1.35,2.34c.75.43,1.36.08,1.36-.78a3,3,0,0,0-1.35-2.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "476.29 200.24 476.03 291.01 337.07 210.78 337.32 120.01 476.29 200.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M479.45,190.67,340,110.15a3.39,3.39,0,0,0-3.42-.33l-2.89,1.68a3.39,3.39,0,0,1,3.42.33l139.45,80.52a10.54,10.54,0,0,1,4.78,8.29l-.29,101.53,2.9-1.68L484.24,199A10.57,10.57,0,0,0,479.45,190.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M359.4,139.38,284.62,96.2c-1-.56-1.77,0-1.77,1.34V100l78.32,45.22v-2.42A4.24,4.24,0,0,0,359.4,139.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M288.2,100.78c0,.47-.34.66-.75.43a1.66,1.66,0,0,1-.74-1.29c0-.48.33-.67.74-.43A1.64,1.64,0,0,1,288.2,100.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M290.6,102.16c0,.48-.33.67-.75.43a1.63,1.63,0,0,1-.74-1.29c0-.47.33-.66.74-.43A1.64,1.64,0,0,1,290.6,102.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M293,103.55c0,.48-.33.67-.74.43a1.65,1.65,0,0,1-.75-1.29c0-.47.34-.67.75-.43A1.66,1.66,0,0,1,293,103.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "361.17 198.52 282.85 153.3 282.85 99.95 361.17 145.17 361.17 198.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "355.05 148.5 307.54 121.07 307.54 119.8 355.05 147.23 355.05 148.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "355.05 151.29 307.54 123.86 307.54 122.59 355.05 150.02 355.05 151.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "355.05 154.09 307.54 126.65 307.54 125.38 355.05 152.81 355.05 154.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "342.84 149.83 307.54 129.45 307.54 128.17 342.84 148.56 342.84 149.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "355.05 161.32 307.54 133.89 307.54 132.62 355.05 160.05 355.05 161.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "355.05 164.12 307.54 136.68 307.54 135.41 355.05 162.84 355.05 164.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "355.05 166.91 307.54 139.47 307.54 138.2 355.05 165.63 355.05 166.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "355.05 171.81 307.54 144.38 307.54 143.1 355.05 170.54 355.05 171.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "355.05 174.6 307.54 147.17 307.54 145.9 355.05 173.33 355.05 174.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "321.28 157.9 307.54 149.96 307.54 148.69 321.28 156.62 321.28 157.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "303.78 142.83 289.11 134.37 289.11 110.62 303.78 119.09 303.78 142.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "441.26 257.39 370.73 216.67 370.73 159.1 441.26 199.82 441.26 257.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M439.36,194.67l-66.72-38.53c-1.06-.6-1.91,0-1.91,1.45v1.54l70.53,40.72v-1.54A4.54,4.54,0,0,0,439.36,194.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M376.5,160.58c0,.51-.36.72-.8.46a1.77,1.77,0,0,1-.81-1.39c0-.52.36-.72.81-.47A1.79,1.79,0,0,1,376.5,160.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M379.09,162.07c0,.52-.36.72-.8.47a1.78,1.78,0,0,1-.81-1.4c0-.51.36-.72.81-.46A1.79,1.79,0,0,1,379.09,162.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M381.69,163.57c0,.51-.36.72-.81.46a1.77,1.77,0,0,1-.8-1.39c0-.51.36-.72.8-.46A1.76,1.76,0,0,1,381.69,163.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "422.38 234.52 389.61 215.6 389.61 179.89 422.38 198.81 422.38 234.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "419.52 205.47 392.17 189.68 392.17 186.33 419.52 202.12 419.52 205.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "403.47 213.49 399.41 211.14 399.41 210.15 403.47 212.5 403.47 213.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "411.93 218.38 404.3 213.97 404.3 212.97 411.93 217.38 411.93 218.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "419.52 212.43 392.17 196.64 392.17 192.83 419.52 208.62 419.52 212.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M418.71,218.23,393,203.38a2,2,0,0,1-.81-1.56v-1.63c0-.6.36-.88.81-.62l25.73,14.85a2,2,0,0,1,.81,1.56v1.63C419.52,218.21,419.16,218.49,418.71,218.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M418.71,227.89,393,213a2,2,0,0,1-.81-1.56v-1.63c0-.6.36-.87.81-.61l25.73,14.85a1.93,1.93,0,0,1,.81,1.55v1.64C419.52,227.88,419.16,228.15,418.71,227.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "332.59 236.23 325.65 240.26 316.92 235.22 323.86 231.19 332.59 236.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.71 242.07 335.77 246.1 327.04 241.06 333.98 237.03 342.71 242.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "320.54 243.23 313.6 247.26 304.87 242.22 311.81 238.19 320.54 243.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "352.82 247.91 345.88 251.94 337.15 246.9 344.09 242.87 352.82 247.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.86 252.92 296.92 256.96 288.19 251.92 295.13 247.88 303.86 252.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "322.32 253.92 315.38 257.95 306.64 252.91 313.59 248.87 322.32 253.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "340.77 254.91 333.83 258.94 325.1 253.9 332.04 249.87 340.77 254.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "350.89 260.75 343.95 264.79 335.21 259.74 342.15 255.71 350.89 260.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "383.18 265.43 376.24 269.46 367.5 264.42 374.44 260.39 383.18 265.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.56 265.6 335.61 269.63 326.88 264.59 333.82 260.56 342.56 265.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "334.21 270.44 327.27 274.48 318.53 269.44 325.48 265.4 334.21 270.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "393.3 271.27 386.36 275.31 377.62 270.26 384.56 266.23 393.3 271.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "371.12 272.44 364.18 276.47 355.45 271.43 362.39 267.39 371.12 272.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "344.33 276.29 337.39 280.32 328.65 275.28 335.6 271.24 344.33 276.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "403.41 277.11 396.47 281.15 387.74 276.11 394.68 272.07 403.41 277.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "362.79 277.28 355.84 281.32 347.11 276.27 354.05 272.24 362.79 277.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "381.24 278.28 374.3 282.31 365.57 277.27 372.51 273.23 381.24 278.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "335.99 281.13 329.05 285.17 320.32 280.12 327.26 276.09 335.99 281.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "354.45 282.13 347.5 286.16 338.77 281.12 345.71 277.08 354.45 282.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "413.53 282.95 406.59 286.99 397.85 281.94 404.79 277.91 413.53 282.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "372.91 283.12 365.96 287.16 357.23 282.11 364.17 278.08 372.91 283.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "391.36 284.12 384.42 288.15 375.69 283.11 382.63 279.08 391.36 284.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "364.57 287.97 357.62 292 348.89 286.96 355.83 282.93 364.57 287.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "423.64 288.8 416.7 292.83 407.97 287.79 414.91 283.75 423.64 288.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "383.02 288.96 376.08 293 367.35 287.96 374.29 283.92 383.02 288.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "401.48 289.96 394.54 293.99 385.8 288.95 392.74 284.92 401.48 289.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "337.77 291.82 330.83 295.85 322.09 290.81 329.03 286.78 337.77 291.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "374.68 293.81 367.74 297.84 359.01 292.8 365.95 288.77 374.68 293.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "433.76 294.64 426.82 298.67 418.09 293.63 425.03 289.59 433.76 294.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "393.14 294.8 386.2 298.84 377.46 293.8 384.4 289.76 393.14 294.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "384.8 299.65 377.86 303.69 369.12 298.64 376.06 294.61 384.8 299.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "443.88 300.48 436.94 304.51 428.2 299.47 435.14 295.44 443.88 300.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "421.71 301.64 414.77 305.67 406.03 300.63 412.97 296.6 421.71 301.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "376.46 304.5 369.52 308.53 350.67 297.65 357.61 293.62 376.46 304.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "454 306.32 447.06 310.35 438.32 305.31 445.26 301.27 454 306.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "413.37 306.49 406.43 310.52 397.69 305.48 404.64 301.44 413.37 306.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "431.82 307.48 424.88 311.51 416.15 306.47 423.09 302.44 431.82 307.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "368.12 309.34 361.18 313.38 332.21 296.65 339.15 292.62 368.12 309.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "405.03 311.33 398.09 315.37 389.35 310.32 396.3 306.29 405.03 311.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "423.49 312.32 416.54 316.36 407.81 311.32 414.76 307.28 423.49 312.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "441.94 313.32 435 317.36 426.27 312.31 433.21 308.28 441.94 313.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "359.78 314.19 352.84 318.23 344.1 313.18 351.04 309.15 359.78 314.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "396.69 316.18 389.75 320.21 381.02 315.17 387.96 311.14 396.69 316.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "415.15 317.17 408.2 321.21 399.47 316.17 406.42 312.13 415.15 317.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "433.61 318.17 426.66 322.2 417.93 317.16 424.87 313.12 433.61 318.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "388.35 321.03 381.41 325.06 372.68 320.01 379.62 315.98 388.35 321.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "406.81 322.02 399.87 326.05 391.14 321.01 398.08 316.98 406.81 322.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "425.27 323.01 418.32 327.05 409.59 322.01 416.53 317.97 425.27 323.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "380.01 325.87 373.07 329.91 364.34 324.86 371.28 320.83 380.01 325.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "398.47 326.87 391.53 330.9 382.8 325.86 389.74 321.82 398.47 326.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "416.93 327.86 409.99 331.89 401.25 326.85 408.19 322.82 416.93 327.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "390.13 331.71 383.19 335.75 374.45 330.7 381.39 326.67 390.13 331.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "408.58 332.71 401.64 336.74 392.91 331.7 399.85 327.66 408.58 332.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "400.25 337.56 393.31 341.59 384.57 336.54 391.51 332.51 400.25 337.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.2 248.07 305.26 252.11 296.53 247.07 303.47 243.03 312.2 248.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "330.66 249.07 323.72 253.11 314.98 248.06 321.92 244.03 330.66 249.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "362.94 253.75 356 257.78 347.27 252.74 354.21 248.71 362.94 253.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.98 258.76 307.04 262.8 298.3 257.76 305.25 253.72 313.98 258.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "373.06 259.59 366.12 263.63 357.39 258.58 364.33 254.55 373.06 259.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "332.44 259.76 325.49 263.79 316.76 258.75 323.71 254.72 332.44 259.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.18 262.62 280.24 266.65 271.51 261.61 278.45 257.57 287.18 262.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "305.64 263.61 298.7 267.64 279.85 256.76 286.79 252.73 305.64 263.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "324.1 264.6 317.15 268.64 308.42 263.6 315.37 259.56 324.1 264.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "361.01 266.6 354.07 270.63 345.33 265.59 352.27 261.55 361.01 266.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "278.84 267.46 271.9 271.5 263.17 266.45 270.11 262.42 278.84 267.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "297.3 268.46 290.36 272.49 281.63 267.45 288.56 263.41 297.3 268.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "315.75 269.45 308.81 273.48 300.08 268.44 307.02 264.41 315.75 269.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "352.68 271.44 345.73 275.48 336.99 270.43 343.94 266.4 352.68 271.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "288.96 273.3 282.02 277.34 273.29 272.29 280.23 268.26 288.96 273.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "307.42 274.3 300.48 278.33 291.74 273.29 298.68 269.26 307.42 274.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "325.87 275.29 318.93 279.32 310.2 274.28 317.14 270.25 325.87 275.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "317.53 280.14 310.59 284.17 301.86 279.13 308.8 275.1 317.53 280.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "327.65 285.98 320.71 290.01 311.98 284.97 318.92 280.94 327.65 285.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "346.11 286.97 339.17 291.01 330.43 285.96 337.37 281.93 346.11 286.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "356.23 292.82 349.29 296.85 340.55 291.81 347.49 287.77 356.23 292.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "339.55 302.51 332.61 306.54 283.4 278.14 290.34 274.1 339.55 302.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "349.66 308.35 342.72 312.38 333.99 307.34 340.93 303.31 349.66 308.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M406.81,158.12c.86.5,1.57.1,1.57-.89a3.46,3.46,0,0,0-1.56-2.7c-.86-.49-1.56-.09-1.56.9A3.41,3.41,0,0,0,406.81,158.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M290.46,147c.33.19.66.39,1,.62,7.42,4.91,12.32,15,17.51,25.68,5.37,11.05,10.92,22.47,19.6,28.37.93.63,1.84,1.2,2.71,1.7,12.57,7.26,17.91,1,18,.93l1.13,1.47c-.25.3-5.8,6.82-19-.82-.92-.54-1.89-1.15-2.89-1.83-9.26-6.28-15-18.08-20.53-29.49-5-10.3-9.73-20-16.56-24.54-.3-.2-.61-.39-.91-.57-8.13-4.69-13.91,1.33-20.57,8.26-7.74,8.06-16.52,17.2-31.16,9.72-1.12-.57-2.2-1.16-3.25-1.77-12.64-7.29-20.35-16.92-27.82-26.25-7-8.71-14.18-17.71-25.47-24.85l-1.06-.65c-11.68-6.74-21.49-2-21.59-1.9l-.91-1.64c.43-.21,10.28-5,22.48,2l1.15.69c11.62,7.35,19,16.53,26.07,25.41,7.64,9.53,14.88,18.58,27.08,25.62q1.56.9,3.24,1.77c14,7.15,22.59-1.78,30.16-9.67C275.38,148.36,281.62,141.86,290.46,147Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M254.51,151.43c23.21,13.4,17.47,61.75,37,73,20.42,11.79,17.79-29.13,37-18.34,19.22,11.09,20.65,73.3,21.16,76.48L159,172.53c.28-2.12,6.53-36.26,20.92-33.58,13,2.42,18.53,39.56,36.87,51.33C231.06,199.44,232.4,138.66,254.51,151.43Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M291.43,142.91a8.33,8.33,0,0,1,3.77,6.52c0,2.4-1.71,3.37-3.79,2.16a8.3,8.3,0,0,1-3.77-6.52C287.65,142.68,289.35,141.71,291.43,142.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "180.13 185.58 179.57 185.3 179.57 86.4 180.13 86.67 180.13 185.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "217.31 206.81 216.76 206.54 216.76 107.63 217.31 107.91 217.31 206.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "250.27 225.82 249.72 225.55 249.72 126.65 250.27 126.92 250.27 225.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "291.41 249.49 290.86 249.22 290.86 150.32 291.41 150.59 291.41 249.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "328.6 271.38 328.04 271.11 328.04 172.2 328.6 172.48 328.6 271.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M261.18,303.13l-42.93,24.95a12.07,12.07,0,0,1-10.92,0l-29.39-17a3.89,3.89,0,0,1-2.28-3.19v3a3.87,3.87,0,0,0,2.28,3.18l29.4,17a12,12,0,0,0,10.91,0l42.93-24.94a3.84,3.84,0,0,0,2.24-3.14v-3A3.83,3.83,0,0,1,261.18,303.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.14,296.81c3,1.74,3,4.57,0,6.32l-42.93,24.95a12.07,12.07,0,0,1-10.92,0l-29.39-17c-3-1.75-3-4.58,0-6.33l42.93-24.94a12,12,0,0,1,10.92,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "257.56 299.69 225.85 281.38 218.29 285.75 250 304.06 257.56 299.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "212.14 297.5 205.04 293.4 212.14 289.3 219.23 293.4 212.14 297.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "203.78 302.32 196.68 298.23 203.78 294.13 210.87 298.23 203.78 302.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "195.57 307.06 188.47 302.97 195.57 298.87 202.66 302.97 195.57 307.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "187.36 311.8 180.26 307.71 187.36 303.61 194.46 307.71 187.36 311.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "220.44 302.29 213.34 298.19 220.44 294.1 227.54 298.19 220.44 302.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "212.08 307.12 204.98 303.02 212.08 298.93 219.18 303.02 212.08 307.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "203.87 311.86 196.78 307.76 203.87 303.67 210.97 307.76 203.87 311.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "195.66 316.6 188.57 312.5 195.66 308.4 202.76 312.5 195.66 316.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "228.58 306.99 221.48 302.89 228.58 298.8 235.67 302.89 228.58 306.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "220.22 311.82 213.12 307.72 220.22 303.62 227.31 307.72 220.22 311.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "212.01 316.56 204.91 312.46 212.01 308.36 219.1 312.46 212.01 316.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "203.8 321.3 196.7 317.2 203.8 313.1 210.9 317.2 203.8 321.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "236.75 311.71 229.65 307.61 236.75 303.51 243.84 307.61 236.75 311.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "228.39 316.53 221.29 312.44 228.39 308.34 235.48 312.44 228.39 316.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "220.18 321.27 213.08 317.18 220.18 313.08 227.27 317.18 220.18 321.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "211.97 326.01 204.87 321.92 211.97 317.82 219.07 321.92 211.97 326.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "192.17 284.2 144.61 256.74 210.66 218.61 258.22 246.06 192.17 284.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "186.29 284.23 138.73 256.77 204.78 218.63 252.34 246.09 186.29 284.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "181.88 191.49 177.29 188.84 177.29 187.59 181.88 190.24 181.88 191.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "219.06 211.91 214.47 209.26 214.47 208.01 219.06 210.66 219.06 211.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "252.29 230.23 247.7 227.58 247.7 226.34 252.29 228.99 252.29 230.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmLanding);
export default __webpack_public_path__ + "static/media/cm-landing.714e4ce92360b23bec5591dc65c632ba.svg";
export { ForwardRef as ReactComponent };